<template lang="pug">
div.has-fixed-footer
    AdminSubnav(v-if="isAdmin")
    NetworkEditCard(v-model="network", :createMode="true" @changedNetwork="onChanged")
</template>

<script>
import NetworkEditCard from "./NetworkEditCard.vue";
import AdminSubnav from "./admin/AdminSubnav.vue";
import {country, badCharsRegex} from "../../config.json";

const badChars = new RegExp(badCharsRegex, "g");

export default {
    components: {NetworkEditCard, AdminSubnav},
    data() {
        return {
            network: {country},
            isChanged: false,
            isAdmin: localStorage.getItem("is_admin") === "1"
        };
    },
    watch: {
      "network.id1"(id) {
        console.log("watch")
        let prefix = "bbmri-eric:networkID:";
        this.network.id = prefix + id.replace(badChars, "");
      }
    },
    methods: {
      onChanged(isChanged) {
        this.isChanged = isChanged;
      },
      created() {
        this.network.id = "";
        // console.log("created")
      },

    }
}
</script>
